<template>
  <div class="box">
    <div class="topbox">
      <div>
        <el-row class="head1">
          <el-col :span="1" style="width: 100px;text-align: center">
            姓名/手机号:
          </el-col>
          <el-col :span="1" style="width: 188px">
            <el-input size="small" placeholder="请输入姓名或手机号" v-model="input1" @keyup.enter.native="search">
            </el-input>
          </el-col>
          <el-col :span="1" style="width: 50px;text-align: right">
            <el-button icon="el-icon-search" @click="search" type="warning" size="small"></el-button>
          </el-col>
        </el-row>

      </div>

    </div>

    <div class="bodbox">
      <div class="bodc">
        <tiao :neir="'会员信息'"></tiao>
        <div class="tablebox">
          <table class="table table-bordered table-hover">
            <thead>
            <tr>
              <th>姓名</th>
              <th>别名</th>
              <th>年龄</th>
              <th>家长姓名</th>
              <th>家长电话</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in vip_list" @click="course_data(item.user_id)" style="cursor: pointer;" :class="{active_tr:(vip_id==item.user_id)}">
              <td>{{ item.baobao_name ? item.baobao_name : '--' }}</td>
              <td>{{ item.baobao_name2 ? item.baobao_name2 : '--' }}</td>
              <td>{{ item.yueling ? item.yueling : '--' }}</td>
              <td>{{ item.name ? item.name : '--' }}</td>
              <td>{{ item.name ? item.name : '--' }}</td>
            </tr>
            <tr>
              <td colspan="4" v-show="data_state" class="no_data">暂无数据</td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>

      <div class="bodc">
        <tiao :neir="'消费计次 '+username"></tiao>
        <div class="tablebox">
          <table class="table table-bordered table-hover">
            <thead>
            <tr>
              <th>商品名称</th>
              <th>剩余次数</th>
              <th>消费日期</th>
              <th>消费次数</th>
              <th>技师</th>
              <th>操作</th>
            </tr>
            </thead>

            <tbody>
            <tr v-for="(item,index) in course_list">
              <td>{{ item.s_name ? item.s_name : '--' }}</td>
              <td>{{ item.y_keshi}}</td>
              <td>
                <el-date-picker style="width: 150px"
                                size="mini"
                                value-format="yyyy-MM-dd"
                                v-model="item.kk_date"
                                type="date"
                                placeholder="选择日期"
                                format="yyyy-MM-dd">
                </el-date-picker>
              </td>
              <td><el-input-number v-model="item.kouke" size="small" controls-position="right" :min="0"></el-input-number></td>
              <td>
                <select class="select3" v-model="item.staff_id" style="height: 28px;padding-left:10px;">
                  <option v-for="item_staff in staff_list" :value="item_staff.user_id">
                    {{item_staff.username}}
                  </option>
                </select>
              </td>
              <td>
                <button @click="do_sign(item)" class="btn_state">
                  计次
                </button>
              </td>
            </tr>
            <tr>
              <td colspan="5" v-show="data_state" class="no_data">暂无数据</td>
            </tr>
            </tbody>

          </table>
        </div>
      </div>
    </div>

    <!--签到-->
    <el-dialog
      title="提示"
      :visible.sync="sign_dialog"
      width="30%">
      <span>是否确认计次？</span>
      <span slot="footer" class="dialog-footer">
		    <el-button @click="sign_dialog = false">取 消</el-button>
		    <el-button type="warning" @click="confirm_sign">确 定</el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>
import tiao from '@/components/tiao.vue'

export default {
  components: {
    tiao
  },
  data() {
    return {
      input2: '',
      options: [],//选择课程
      value: [],
      dialogVisible: false,
      vip_list: [],//搜索
      input1: '',
      time1: '',
      data_state: true,
      course_list: [],//补签课程
      vip_id: '',//会员ID
      sign_dialog: false,//签到
      n_id: '',//签到数据
      t: '',
      p_id: '',
      xh: '',
      s_id: '',
      q_index: '',
      k_index: '',
      token: '',
      loadings: '',
      username:'',
      staff_list:'',
      staff_id:'',
      kk_date:'',
      kouke:'',
    }
  },
  mounted() {
    this.token = $.cookie('token');
    this.get_staff();
  },
  methods: {
    //搜索
    search() {
      let that = this
      this.vip_id = ""
      $.ajax({
        url: process.env.apiUrl + "saas/Qiandao/cha",
        type: "post",
        dataType: 'json',
        data: {
          token: that.token,
          name: that.input1,
          time: that.time1
        },
        success: function (res) {
          if(res.status == 1){
            that.data_state = false
            that.vip_list = res.data
            that.username = res.username
            that.course_data(res.user_id);
          }
        }
      });
    },
    //所有签约商品项目
    course_data(id) {
      this.vip_id = id
      let that = this
      $.ajax({
        url: process.env.apiUrl + "saas/user/get_hy_item",
        type: "post",
        dataType: 'json',
        data: {
          token: that.token,
          user_id: id
        },
        success: function (res) {
          that.course_list = res.data
        }
      });
    },
    //获取员工信息
    get_staff(){
      let that = this;
      $.ajax({
        url: process.env.apiUrl + "saas/user/allstaff",
        type: "post",
        data: {
          token: that.token
        },
        success: function (res) {
          that.staff_list = res.data;
        },
      });
    },
    //确认签到
    do_sign(info) {

      this.$confirm('确认要消费计次吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let that = this
        this.loadings = this.$loading({
          lock: true,
          text: '加载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        $.ajax({
          url: process.env.apiUrl + "saas/Qiandao/do_sign",
          type: "post",
          dataType: 'json',
          data: {
            token: that.token,
            user_id: that.vip_id,
            info:info
          },
          success: function (data) {

            if (data.status == 1) {
              that.$alert(data.msg)
              // that.$message.success(data.msg);
              that.course_data(that.vip_id);
            } else {
              that.$message.error(data.msg);
            }
            that.loadings.close()
          }
        });

      }).catch(() => {
      });
    },
    jump: function (d) {
      this.$router.push(d)
    },
    change: function (item, index) {
      console.log(item);
      this.value[index] = item;
    },
    buqian: function (i) {
      this.dialogVisible = true
    },

  }
}
</script>

<style scoped>
.active_tr{
  background-color: palegreen;
}
.btn_state {
  padding: 3px 4px;
  border: 0;
  border-radius: 2px;
  background: #E6BE8A;
  color: white;
  cursor: pointer;
}

.btn_state2 {
  padding: 3px 4px;
  border: 0;
  border-radius: 2px;
  background: #5cb85c;
  color: white;
  cursor: pointer;
}

.el-button--small, .el-button--small.is-round {
  padding: 8px 15px;
}

* {
  font-size: 14px;
  color: #666;
}

.box {
  padding-left: 35px;
  padding-right: 35px;
  padding-top: 15px;
}

.topbox {
  height: 60px;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
}

.head1 {
  height: 32px;
  line-height: 32px;
}

.bodbox {
  display: flex;
  display: -webkit-flex;
}

.bodc {
  width: 50%;
  padding-left: 10px;
  padding-right: 10px;
}

.bodc:nth-of-type(1) {
  border-right: 1px solid #f2f2f2;
}

.tablebox {
  padding-left: 5px;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// src/pages/qiandao/xiaofei.vue